
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import JourneysContent from "./Components/JournesyContent.vue";

export default defineComponent({
  name: "JourneysPage",
  components: {
    BreadCrumb,
    JourneysContent,
  },
});
